<template>
    <div class="bg-white">
        <div class="draft-card user-select-none h-100" :class="{'selected' : draft.id === store.selectedDraft}">
            <div class="draft-card-body d-flex flex-column align-items-center justify-content-center h-100 cursor-pointer" @click="store.selectedDraft = draft.id">
                <img :src="draft.thumb" class="card-icon filter-none mb-2">
                <p class="fs-5 text-center">{{draft.title}}</p>
            </div>

            <div class="pe-none position-absolute inset-0 d-flex justify-content-end align-items-start p-2">
                <button type="button" class="delete-btn btn btn-clear text-dark pe-all" @click="destroy">
                    <i class="las la-minus-circle"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .delete-btn {
        display: none;
        opacity: .6;

        &:hover {
            opacity: 1;
        }
    }

    .draft-card {
        position: relative;
        padding: 1rem;
        opacity: 0.7;

        &:hover {
            opacity: 1;

            .delete-btn {
                display: block;
            }
        }

        &.selected {
            opacity: 1;
            outline: 2px solid black;

            p {
                font-weight: 600;
            }
        }
    }

    .card-icon {
        max-width: 100px;
    }
</style>

<script>
import {useDraftStore} from "./store";
import axios from 'axios';

export default {
    props: ['draft'],
    setup() {
        const store = useDraftStore();
        return {store};
    },
    methods: {
        destroy() {
            let app = this;

            $swal.fire({
                title: $trans('storefront::image_editor.draft_destroy_confirm_title'),
                text: $trans('storefront::image_editor.draft_destroy_confirm_description'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: $trans('storefront::image_editor.draft_destroy_confirm_text')
            }).then((result) => {
                if (result.isConfirmed) {
                    app.store.loading = true;
                    axios.post('/image-editor/drafts/destroy', { id: app.draft.id}).then(function (response) {
                        app.$emit('onDestroy');
                        $swal.fire({
                            title: $trans('storefront::image_editor.draft_destroyed_title'),
                            text: $trans('storefront::image_editor.draft_destroyed_description'),
                            icon: "success"
                        });
                    }).catch(function (error) {
                        console.log(error);
                        $swal.fire($trans('storefront::image_editor.error'), $trans('storefront::image_editor.error_general'),'error');
                    }).finally(()=> {
                        app.store.loading = false;
                    })
                }
            });
        }
    }
}
</script>
